import { postStripeCheckoutSuccess } from '../api/api';

const handleSuccess = async (sessionID, country) => {
  try {
    await postStripeCheckoutSuccess(sessionID, country);
  } catch (error) {
    console.error(error);
  }
};

export const HandleProcessStripeCheckout = () => {
  const query = window.location.search;
  const search = new URLSearchParams(query);
  const id = search.get('session_id');
  const country = search.get('country');
  if (id) {
    handleSuccess(id, country);
  }
};
